import { Typography } from '@mui/material'
import { FC } from 'react'
import GridContainer from '../GridContainer'
import { colors } from '../../theme/colors'

export interface BannerProps {
  title: string
  label?: string
  subtitle?: string
}

const Banner: FC<BannerProps> = ({ title, label = 'Mission Lane LLC', subtitle = '' }) => (
  <div className="bg-green-900 md:bg-cover md:bg-right md:bg-mlTracksMiniRight2">
    <GridContainer>
      <div className="col-start-1 col-span-full md:col-span-9 py-16 md:py-24">
        <Typography variant="h5" sx={{ color: colors.Green[400] }}>
          {label}
        </Typography>
        <Typography variant="h1" sx={{ color: colors.White }} className="my-4">
          {title}
        </Typography>
        <Typography variant="p2" sx={{ color: colors.Green[400] }}>
          {subtitle}
        </Typography>
      </div>
    </GridContainer>
  </div>
)

export default Banner
